<script setup lang="ts">
import { ref } from 'vue';
import HTMLEditor from '@/components/common/HTMLEditor.vue';

interface Props {
  dataEdited?: string | null;
  permission: boolean;
}
const props = defineProps<Props>();

const emits = defineEmits<{ handleSaveDataEdit: [value: any] }>();

const isEdit = ref(false);

const editedData = ref(props.dataEdited);

const openEdit = () => {
  isEdit.value = true;
};

const handleSaveDataEdit = () => {
  isEdit.value = false;
  emits('handleSaveDataEdit', editedData.value);
};

const cancelEdit = () => {
  isEdit.value = false;
  editedData.value = props.dataEdited;
};

const updateValue = (event: string) => {
  emits('handleSaveDataEdit', event);
};
</script>

<template>
  <div v-if="!isEdit" class="flex">
    <div class="w-full">
      <HTMLEditor :readonly="true" v-model="editedData" class="custom-editor" @update:modelValue="updateValue($event)" />
    </div>
    <span class="text-center">
      <i v-if="permission" class="pi pi-pencil edit-pi cursor-pointer" @click="openEdit()"></i>
    </span>
  </div>
  <div v-else class="flex">
    <div class="w-full">
      <HTMLEditor v-model="editedData" class="custom-editor" />
    </div>
    <div class="text-center flex flex-col">
      <i class="pi pi-check edit-pi cursor-pointer" @click="handleSaveDataEdit()"></i>
      <i class="pi pi-times edit-pi cursor-pointer" @click="cancelEdit()"></i>
    </div>
  </div>
</template>

<style scoped lang="scss">
.edit-pi {
  width: 40px;
  height: 40px;
  line-height: 40px;
}
</style>
